import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useIsMobile, webMediaQuery} from '../../../styles';
import ComicsChapterCard from '../ComicChapterCard';

const ChapterRow = props => {
    const isMobile = useIsMobile();

    const [cardWidth, setCardWidth] = useState(undefined);

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        handleWindowResize();

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
        // eslint-disable-next-line
    }, []);

    const handleWindowResize = () => {
        if (window.innerWidth > 1024) {
            setCardWidth(
                (Math.min(window.innerWidth, 1092) - 80) /
                    (props.small ? 4 : 3),
            );
        } else if (window.innerWidth > 600) {
            setCardWidth(props.small ? 252 : 338);
        } else {
            setCardWidth(props.small ? 252 : window.innerWidth - 50);
        }
    };

    return (
        <Container
            id="comics-row"
            padding={isMobile ? 25 : 40}
            small={props.small}
        >
            {props.chapters.map((item, index) => {
                return (
                    <ComicsChapterCard
                        chapter={item}
                        maskStart={index !== 0}
                        maskEnd={
                            index !== props.chapters.length - 1 || index === 0
                        }
                        key={index.toString()}
                        horizontal
                        width={cardWidth}
                        height={props.small ? 195 : 225}
                        index={props.indexed ? index : null}
                    />
                );
            })}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: max-content;
    padding: 0px ${props => props.padding}px;
    height: ${props => (props.small ? 215 : 245)}px;
    justify-content: center;
    padding-top: 10px;
    position: relative;
    ${webMediaQuery} {
        padding-left: 0px;
        padding-right: 0px;
    }
`;

export default ChapterRow;
